// extracted by mini-css-extract-plugin
module.exports = {"big-main-title":"style_big-main-title__m1DjK"};